import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import {
    OreButton,
    OreDivider,
    OreStack,
} from '@edenredespana/oreneta'
import { navigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'

export const NewTicketFooter = (): JSX.Element => {
    const { t } = useTranslation()
    const { step, isNextEnabled, handleNextStep, handlePreviousStep, saveCaseRequest } = useHelpCenter()
    const navigate = useNavigate()

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreDivider />
            <OreStack space="large" direction="row" placeContent="space-between">
                <OreButton onClick={step > 1 ? handlePreviousStep :
                    () => navigate(navigationRoutes.myTickets)} category={'secondary'}>
                    {step > 1 ? t(HelpCenterTranslations.previous) : t(HelpCenterTranslations.cancel)}
                </OreButton>
                <OreButton
                    onClick={step === 4 ? saveCaseRequest : handleNextStep}
                    category={'primary'}
                    disabled={!isNextEnabled}
                >{step === 4 ? t(HelpCenterTranslations.submit) : t(HelpCenterTranslations.next)}</OreButton>
            </OreStack>
        </OreStack>
    )
}


